import { CellProps } from 'react-table';
import { TableCustomCell } from '../../../../component/table/components/TableCustomCell';
import { formatMoney } from '../../../../utils/FormatUtils';

const UnitPriceCell = ({ row, tableOptions }: CellProps<any>) => {
	const { handleRenderPrice } = tableOptions;
	const rowData = row.original;

	const visitObjectTypeCode = rowData?.visitObjectType?.code;
	const data = handleRenderPrice(rowData, visitObjectTypeCode);

	return <TableCustomCell className="text-end " data={formatMoney(data) || 0} />;
};

export default UnitPriceCell;
